import type { IFooter } from "~/types/components/footer.type";

export const useFooter = () => {
    const { t } = useI18n();

    const footerData: IFooter = {
        subtitle: t("components_footer_desc"),
        social: [
            {
                link: "https://www.facebook.com/profile.php?id=100095500926253",
                icon_src: "fa6-brands:facebook",
                ariaLabel: "Facebook link of AI home design",
            },
            {
                link: "https://www.instagram.com/theaihomedesign/",
                icon_src: "fa6-brands:instagram",
                ariaLabel: "Instagram link of AI home design",
            },

            {
                link: "https://www.linkedin.com/showcase/aihomedesign/",
                icon_src: "fa6-brands:linkedin",
                ariaLabel: "Linkedin link of AI home design",
            },
            {
                link: "https://www.youtube.com/channel/UC-o_4KqogNzaieNi1bSzb3Q",
                icon_src: "fa6-brands:youtube",
                ariaLabel: "Youtube link of AI home design",
            },
            {
                link: "https://www.pinterest.de/TheAIHomeDesign/",
                icon_src: "fa6-brands:pinterest",
                ariaLabel: "Pinterest link of AI home design",
            },
            {
                link: "https://www.tiktok.com/@theaihomedesign",
                icon_src: "fa6-brands:tiktok",
                ariaLabel: "Tiktok link of AI home design",
            },
            {
                link: "https://twitter.com/TheAIHomeDesign",
                icon_src: "pajamas:twitter",
                ariaLabel: "Twitter link of AI home design",
            },
        ],
        furnishing: [
            {
                title: t("components_header_PE_title"),
                content: [
                    {
                        text: t("global_serviceName_dayToDusk"),
                        link: "/day-to-dusk",
                    },
                    {
                        text: t("global_serviceName_imageEnhancement"),
                        link: "/image-enhancement",
                    },

                    {
                        text: t("global_serviceName_itemRemoval"),
                        link: "/item-removal",
                    },
                ],
                isArray: true,
            },
        ],

        realEstateHub: [
            {
                title: t("components_header_VS_title"),
                content: [
                    {
                        text: t("global_serviceName_virtualStaging"),
                        link: "/virtual-staging",
                    },
                    {
                        text: t("global_serviceName_humanVirtualStaging"),
                        link: "/virtual-staging#virtual-staging-by-human",
                    },
                ],
                isArray: true,
            },
        ],

        company: [
            {
                title: t("components_footer_company"),
                content: [
                    {
                        text: t("components_footer_pricing"),
                        link: "/pricing",
                    },
                    {
                        text: t("components_header_b2b"),
                        link: "/b2b",
                    },
                    {
                        text: t("components_footer_affiliateProgram"),
                        link: "/affiliate-program",
                    },
                    {
                        link: "/b2b#api-access",
                        text: t("components_footer_apiDocumentation"),
                    },

                    {
                        text: t("components_footer_ideationCenter"),
                        link: "/ideas",
                    },
                    {
                        text: t("components_footer_changeLog"),
                        link: "https://aihomedesign.com/whats-new/",
                        badge: t("components_footer_updated"),
                    },
                    {
                        text: t("components_footer_blog"),
                        link: "https://aihomedesign.com/blog/",
                    },
                ],
                isArray: true,
            },
        ],

        b2b: [
            {
                title: t("components_header_b2bSolutions"),
                content: [
                    {
                        text: t("components_header_b2b"),
                        link: "/b2b",
                    },
                    {
                        text: t("components_footer_affiliateProgram"),
                        link: "/affiliate-program",
                    },

                    {
                        link: "/b2b#api-access",
                        text: t("components_footer_apiDocumentation"),
                    },
                ],
                isArray: true,
            },
        ],

        renovation: [
            {
                title: t("components_header_HR"),
                content: [
                    // {
                    //     text: t("components_header_ID_title"),
                    //     link: "/interior-design",
                    // },
                    {
                        text: t("global_serviceName_creativeDesigner"),
                        link: "/interior-design#ai-interior-designer",
                    },

                    {
                        text: t("global_serviceName_furnitureReplacement"),
                        link: "/interior-design#furniture-replacement",
                    },
                    {
                        text: t("global_serviceName_fullSetReplacement"),
                        link: "/interior-design#full-set-replacement",
                    },
                    // {
                    //     text: t("components_header_HR_title"),
                    //     link: "/home-renovation",
                    // },
                    {
                        text: t("global_serviceName_wallChange"),
                        link: "/home-renovation#wall-change",
                    },
                    {
                        text: t("global_serviceName_floorChange"),
                        link: "/home-renovation#floor-change",
                    },
                    {
                        text: t("global_serviceName_ceilingChange"),
                        link: "/home-renovation#ceiling-change",
                    },
                    {
                        text: t("global_serviceName_backSplashChange"),
                        link: "/home-renovation#backsplash-change",
                    },
                    {
                        text: t("global_serviceName_underConstruction"),
                        link: "/home-renovation#under-construction",
                    },
                ],
                isArray: true,
            },
        ],

        bottomLinks: {
            links: [
                {
                    text: t("components_footer_privacyPolicy"),
                    link: "/privacy-policy",
                },
                {
                    text: t("components_footer_refundPolicy"),
                    link: "/refund-policy",
                },
                {
                    text: t("components_footer_terms"),
                    link: "/terms-and-conditions",
                },
            ],
            copyRight: t("components_footer_copyright"),
        },
    };
    return { footerData };
};
